import ApiService from "../services/api";
import { Consultant, ConsultantFormData } from "../models/consultant";

export const fetchConsultants = async (params: { page?: number, limit?: number }): Promise<Consultant[]> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.get<any>(`/users/consultants/all`, { params });
    if (response.status !== 200) throw new Error("Error fetching consultants");
    
    return response.data.items.map((consultant: any) => ({
      id: consultant.id,
      firstName: consultant.firstName,
      lastName: consultant.lastName,
      accountId: consultant.accountId,
      email: consultant.email,
      phoneNumber: consultant.phoneNumber,
      dn: consultant.dn,
      createdAt: consultant.createdAt ? new Date(consultant.createdAt) : undefined,
      updatedAt: consultant.updatedAt ? new Date(consultant.updatedAt) : undefined,
    }));
  } catch (error) {
    console.error('Error fetching consultants:', error);
    return [];
  }
};

export const createConsultant = async (data: ConsultantFormData): Promise<Consultant | null> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.post<any>('/users/consultants', data);
    if (response.status !== 200) throw new Error("Error creating consultant");
    
    return {
      id: response.data.id,
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      accountId: response.data.accountId,
      email: response.data.email,
      phoneNumber: response.data.phoneNumber,
      dn: response.data.dn,
      createdAt: response.data.createdAt ? new Date(response.data.createdAt) : undefined,
      updatedAt: response.data.updatedAt ? new Date(response.data.updatedAt) : undefined,
    };
  } catch (error) {
    console.error('Error creating consultant:', error);
    return null;
  }
};

export const updateConsultant = async (id: string, data: ConsultantFormData): Promise<Consultant | null> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.post<any>(`/users/consultants`, {...data, id});
    if (response.status !== 200) throw new Error("Error updating consultant");
    
    return {
      id: response.data.id,
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      accountId: response.data.accountId,
      email: response.data.email,
      phoneNumber: response.data.phoneNumber,
      dn: response.data.dn,
      createdAt: response.data.createdAt ? new Date(response.data.createdAt) : undefined,
      updatedAt: response.data.updatedAt ? new Date(response.data.updatedAt) : undefined,
    };
  } catch (error) {
    console.error('Error updating consultant:', error);
    return null;
  }
};

export const deleteConsultant = async (id: string): Promise<boolean> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.delete(`/users/consultants/${id}`);
    return response.status === 200;
  } catch (error) {
    console.error('Error deleting consultant:', error);
    return false;
  }
};
